import React from 'react'
import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../final-form/MaskedField'

export function CpfField(props: MaskedFieldProps) {
  return <MaskedField mask={masks.cpf} placeholder='000.000.000-00' parse={onlyNumbers} {...props} />
}
